export const initialState = {
    pickup_latitude: null,
    pickup_longitude: null,
    pickup_address: "",
    pet_ids: [],
    clean_pet: false,
    scheduled_at: false,
    scheduled_time: null,
    emergency_no: "",
    promo_code: "",
    duration_walk: "",
    tool_ids: [],
    services: ["walk"],
    day: "",
    walkSlot: null,
    slot_token: null,
    scheduleType:"instant",
    termsAccepted:false
};

export function walkReducer(state, action) {
    switch (action.type) {
        case "UPDATE_FIELD":
            return { ...state, [action.field]: action.payload };
        case "UPDATE_DAY":
            // When the day changes, also reset any previously selected slots.
            return { ...state, day: action.payload, walkSlot: null };
        case "SET_WALK_SLOT":
            return { ...state, walkSlot: action.payload };
        case "LOAD_ITEM":
            return { ...state, ...action.payload };
        // Add any additional actions you require.
        default:
            return state;
    }
}


// export function walkReducer(state, action) {
//     switch (action.type) {
//         case 'UPDATE_DAY':
//             return {
//                 ...state,
//                 day: action.payload,
//                 // Reset the appropriate slot(s) when the day changes.
//                 walkSlot: null,
//             };
//         case 'UPDATE_FIELD':
//             return {
//                 ...state,
//                 [action.field]: action.payload,
//             };
//         case 'SET_WALK_SLOT':
//             return {
//                 ...state,
//                 walkSlot: action.payload,
//             };
//         default:
//             return state;
//     }
// }
